
export default function About() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-4 py-2 rounded-full mb-6">
              <i className="ri-award-line text-lg"></i>
              <span className="text-sm font-semibold">Bulk Order Specialists</span>
            </div>
            
            <h2 className="text-5xl font-bold text-gray-900 mb-6">
              Your Trusted Partner for Large-Scale Laundry Solutions
            </h2>
            
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Golden Dry Cleaning and Laundry Services has been the preferred choice for businesses and organizations requiring professional bulk laundry services for over 15 years. We specialize in handling large-volume orders with precision, care, and efficiency.
            </p>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our state-of-the-art facility and experienced team ensure that every piece of fabric receives the golden standard of care it deserves. From hotels and hospitals to corporate offices and restaurants, we deliver exceptional results that keep your business running smoothly.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                  <i className="ri-leaf-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Eco-Friendly</h3>
                  <p className="text-sm text-gray-600">Sustainable practices for bulk orders</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                  <i className="ri-time-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Fast Turnaround</h3>
                  <p className="text-sm text-gray-600">Quick processing for large volumes</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                  <i className="ri-shield-check-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Quality Assured</h3>
                  <p className="text-sm text-gray-600">Consistent excellence in every order</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                  <i className="ri-truck-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Free Delivery</h3>
                  <p className="text-sm text-gray-600">Complimentary pickup & delivery</p>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="flex -space-x-3">
                <div className="w-12 h-12 rounded-full bg-amber-200 border-2 border-white flex items-center justify-center">
                  <i className="ri-user-line text-amber-700"></i>
                </div>
                <div className="w-12 h-12 rounded-full bg-amber-300 border-2 border-white flex items-center justify-center">
                  <i className="ri-user-line text-amber-800"></i>
                </div>
                <div className="w-12 h-12 rounded-full bg-amber-400 border-2 border-white flex items-center justify-center">
                  <i className="ri-user-line text-amber-900"></i>
                </div>
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-900">500+ Business Clients</p>
                <p className="text-xs text-gray-600">Trust us with their laundry needs</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <div className="w-full h-[600px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/4019ae1a7b3d941491df756128ead087.jpg"
                  alt="Professional Laundry Service"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="absolute -bottom-8 -left-8 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 rounded-full">
                  <i className="ri-calendar-check-line text-amber-600 text-2xl"></i>
                </div>
                <div>
                  <p className="text-3xl font-bold text-gray-900">15+</p>
                  <p className="text-sm text-gray-600">Years Experience</p>
                </div>
              </div>
              <p className="text-xs text-gray-500">Serving businesses with excellence since 2010</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
